/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OrganizationInvitation,
  OrganizationInvitation$inboundSchema,
} from "./organizationinvitation.js";

export type ListInvitesResult = {
  /**
   * Pending invitations for the organization only; accepted, expired, and revoked invitations are omitted.
   */
  invitations: Array<OrganizationInvitation>;
};

/** @internal */
export const ListInvitesResult$inboundSchema: z.ZodMiniType<
  ListInvitesResult,
  unknown
> = z.object({
  invitations: z.array(OrganizationInvitation$inboundSchema),
});

export function listInvitesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListInvitesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListInvitesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListInvitesResult' from JSON`,
  );
}
